<template>
  <v-row align="center" justify="center">
    <v-progress-circular indeterminate size="50" width="5" color="primary"></v-progress-circular>
  </v-row>
</template>

<script>

export default {
  name: "Loading"
};
</script>